// extracted by mini-css-extract-plugin
export default {"warning":"CancelOfferForm_warning__iCSyk","checkboxes":"CancelOfferForm_checkboxes__VmImP","label":"CancelOfferForm_label__fi-cv"};